// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4VvTb","counterTextWrapper":"styles_counterTextWrapper__gxQme","counterText":"styles_counterText__aD7Pf","count":"styles_count__5tnSu"};